var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import AccessControlPermissionItems from '@project/containers/AccessControlPermissionItems/Loadable';
import AccessControlAPIKeys from '@project/containers/AccessControlAPIKeys/Loadable';
import AccessControlRoles from '@project/containers/AccessControlRoles/Loadable';
import AccessControlTargetPermissions from '@project/containers/AccessControlTargetPermissions/Loadable';
import AccessControlRolePermissions from '@project/containers/AccessControlRolePermissions/Loadable';
import Translations from '@project/containers/Translations/Loadable';
import Translation from '@project/containers/Translation/Loadable';
import Languages from '@project/containers/Languages/Loadable';
import State from '@project/containers/State/Loadable';
import Storage from '@project/containers/Storage/Loadable';
import Variable from '@project/containers/Variable/Loadable';
import Environment from '@project/containers/Environment/Loadable';
import StylesListPage from '@project/containers/StylesListPage/Loadable';
import StylesPage from '@project/containers/StylesPage/Loadable';
import StyleNew from '@project/containers/StyleNew/Loadable';
import LogicBuilderPage from '@project/containers/LogicBuilderPage/Lodable';
import ViewNew from '@project/containers/ViewNew/Loadable';
import LegacyViewBuilder from '@project/containers/ViewBuilder/LegacyViewBuilder/Loadable';
import Dataset from '@project/containers/DatasetDetails/Loadable';
import DatasetRow from '@project/containers/DatasetRow/Loadable';
import PushNotificationDetailsPage from '@project/containers/PushNotificationDetailsPage/Loadable';
import ItemCopy from '@project/containers/ItemCopy/Loadable';
import DatasetsList from '@project/containers/DatasetsList/Loadable';
import DatasetNew from '@project/containers/DatasetNew/Loadable';
import DatasetEdit from '@project/containers/DatasetEdit/Loadable';
import MediaExplorer from '@project/containers/MediaExplorer/Loadable';
import Versions from '@project/containers/Versions/Loadable';
import VersionNew from '@project/containers/VersionNew/Loadable';
import PlatformsPage from '@project/containers/Publishing/Loadable';
import PlatformsWebPage from '@project/containers/Publishing/Web/Loadable';
import PlatformsPlayStorePage from '@project/containers/Publishing/PlayStore/Loadable';
import PlatformsAppStorePage from '@project/containers/Publishing/AppStore/Loadable';
import PlatformsBuildsPage from '@project/containers/Publishing/Distribution/Loadable';
import PublicationsPage from '@project/containers/PublicationsPage/Loadable';
import PublicationsUpsertPage from '@project/containers/PublicationsUpsertPage/Loadable';
import Groups from '@project/containers/Groups/Loadable';
import GroupNew from '@project/containers/GroupNew/Loadable';
import AdminNew from '@project/containers/AdminNew/Loadable';
import Permissions from '@project/containers/Permission/Loadable';
import DataSetPermissions from '@project/containers/DatasetRulesPage/Loadable';
import TargetPermissions from '@project/containers/TargetPermissions/Loadable';
import AppAdminPermissions from '@project/containers/AppAdminPermissions/Loadable';
import GroupDetails from '@project/containers/GroupDetails/Loadable';
import AppAdminDetails from '@project/containers/AppAdminDetails/Loadable';
import AppUsers from '@project/containers/AppUsers/Loadable';
import UserGroups from '@project/containers/UserGroups/Loadable';
import AppUserEdit from '@project/containers/AppUserEdit/Loadable';
import UserInvite from '@project/containers/UserInvite/Loadable';
import AppOverview from '@project/containers/AppOverview/Loadable';
import AppSettings from '@project/containers/AppSettings/Loadable';
import IntegrationsPage from '@project/containers/Integrations/IntegrationsPage/Loadable';
import IntegrationNew from '@project/containers/Integrations/IntegrationNew/Loadable';
import Integration from '@project/containers/Integrations/IntegrationPage/Loadable';
import IntegrationMethodCreatePage from '@project/containers/Integrations/IntegrationMethodCreatePage/Loadable';
import Admins from '@project/containers/Admins/Loadable';
import CreateAdminRole from '@project/containers/CreateAdminRole/Loadable';
import AppAdmins from '@project/containers/AppAdmins/Loadable';
import InviteAppAdmin from '@project/containers/InviteAppAdmin/Loadable';
import ViewsPage from '@project/containers/ViewsPage/Loadable';
import OldPushNotifications from '@project/containers/PushNotifications/OldPushNotifications';
import PushNotifications from '@project/containers/PushNotifications/Loadable';
import PushNotificationTemplates from '@project/containers/PushNotificationTemplates/Loadable';
import PushNotificationTemplatesEdit from '@project/containers/PushNotificationTemplatesEdit/Loadable';
import MakeTemplateBasicPage from '@project/containers/MakeTemplateBasicPage/Loadable';
import SelectPreview from '@project/containers/SelectPreview/Loadable';
import personalizationPage from '@project/containers/PersonalizationPage/Loadable';
import TemplatePublishPage from '@project/containers/TemplatePublishPage/Loadable';
import PatchSelectRedirectPage from '@project/containers/PatchSelectRedirectPage/Loadable';
import PushNotificationsSenderApps from '@project/containers/PushNotificationsSenderApps';
import UsersSharedApps from '@project/containers/UsersSharedApps';
export var routes = [
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/versions',
        pageComponent: VersionNew,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/versions/list',
        pageComponent: Versions,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/configuration',
        pageComponent: PlatformsPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/configuration/web',
        pageComponent: PlatformsWebPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/configuration/play-store',
        pageComponent: PlatformsPlayStorePage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/configuration/app-store',
        pageComponent: PlatformsAppStorePage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/distribution',
        pageComponent: PlatformsBuildsPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/publications',
        pageComponent: PublicationsPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/publications/new',
        pageComponent: PublicationsUpsertPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/publications/:platform/:publicationId([0-9]+)/edit',
        pageComponent: PublicationsUpsertPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/copy',
        pageRenderer: function (props) { return _jsx(ItemCopy, __assign({}, props, { type: "app" })); },
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/permissions',
        pageRenderer: function (props) { return (_jsx(Permissions, __assign({}, props, { type: "app", baseUrl: "/organizations/:organizationId/apps", crumbIter: 0 }))); },
    },
    {
        path: '/organizations/:organizationId/apps/:appId/patchwork/:patchworkId([0-9]+)/permissions',
        pageRenderer: function (props) { return (_jsx(Permissions, __assign({}, props, { type: "patchwork", baseUrl: "/patchworks", crumbIter: 1, crumbSkip: 1 }))); },
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/views',
        pageComponent: ViewsPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/views/new',
        pageComponent: ViewNew,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/views/:viewId',
        pageComponent: LegacyViewBuilder,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/views/:viewId/copy',
        pageRenderer: function (props) { return _jsx(ItemCopy, __assign({}, props, { type: "view" })); },
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/views/:viewId/permissions',
        pageRenderer: function (props) { return (_jsx(Permissions, __assign({}, props, { type: "view", baseUrl: "/views", crumbIter: 2 }))); },
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/logic/:logicId?',
        pageComponent: LogicBuilderPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/logic/:logicId/:reDirectPatchId',
        pageComponent: LogicBuilderPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/datasets',
        pageComponent: DatasetsList,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/datasets/new',
        pageComponent: DatasetNew,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/datasets/:datasetId',
        pageComponent: Dataset,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/datasets/:datasetId/settings',
        pageComponent: DatasetEdit,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/datasets/:datasetId/copy',
        pageRenderer: function (props) { return _jsx(ItemCopy, __assign({}, props, { type: "dataset" })); },
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/datasets/:datasetId/rules',
        pageRenderer: function (props) { return (_jsx(DataSetPermissions, __assign({}, props, { type: "dataset", baseUrl: "/datasets", crumbIter: 2 }))); },
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/datasets/:datasetId/permissions',
        pageRenderer: function (props) { return (_jsx(Permissions, __assign({}, props, { type: "dataset", baseUrl: "/datasets", crumbIter: 2 }))); },
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/datasetitems/:datasetId/permissions',
        pageRenderer: function (props) { return (_jsx(Permissions, __assign({}, props, { type: "dataset-items", baseUrl: "/datasets", crumbIter: 2 }))); },
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/datasets/:datasetId/addrow',
        pageComponent: DatasetRow,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/datasets/:datasetId/edit/:rowId',
        pageComponent: DatasetRow,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/datasets/:datasetId/edit/:rowId/sendPush',
        pageComponent: PushNotificationDetailsPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/integrations',
        pageComponent: IntegrationsPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/integrations/new',
        pageComponent: IntegrationNew,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/integrations/:integrationId',
        pageComponent: Integration,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/integrations/:integrationId/edit',
        pageRenderer: function (props) { return _jsx(IntegrationNew, __assign({}, props, { edit: true })); },
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/integrations/:integrationId/method/new',
        pageComponent: IntegrationMethodCreatePage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/integrations/:integrationId/method/:methodId',
        pageRenderer: function (props) { return _jsx(IntegrationMethodCreatePage, __assign({}, props, { edit: true })); },
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/media/:folderId([0-9]+)/permissions',
        pageRenderer: function (props) { return (_jsx(TargetPermissions, __assign({}, props, { crumbIter: 0, target: "folder:".concat(props.match.params.folderId) }))); },
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/media/*',
        pageComponent: MediaExplorer,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/styles',
        pageComponent: StylesListPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/styles/new',
        pageComponent: StyleNew,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/styles/:styleId',
        pageComponent: StylesPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/styles/:styleId/copy',
        pageRenderer: function (props) { return _jsx(ItemCopy, __assign({}, props, { type: "style" })); },
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/styles/:styleId/permissions',
        pageRenderer: function (props) { return (_jsx(Permissions, __assign({}, props, { type: "style", baseUrl: "/styles", crumbIter: 2 }))); },
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/translations',
        pageComponent: Translations,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/translations/edit',
        pageComponent: Translation,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/languages',
        pageComponent: Languages,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/state',
        pageComponent: State,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/storage',
        pageComponent: Storage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/variables',
        pageComponent: Variable,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/environments',
        pageComponent: Environment,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/keys',
        pageComponent: AccessControlAPIKeys,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/access/targets',
        pageComponent: AccessControlPermissionItems,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/access/targets/:targetId',
        pageComponent: AccessControlTargetPermissions,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/roles',
        pageComponent: AccessControlRoles,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/roles/:roleId',
        pageComponent: AccessControlRolePermissions,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/permissions/:groupId',
        pageComponent: AppAdminPermissions,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/users',
        pageComponent: AppUsers,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/users/:userId([0-9]+)/edit',
        pageComponent: AppUserEdit,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/users/invite',
        pageComponent: UserInvite,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/shareusers',
        pageComponent: UsersSharedApps,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/groups',
        pageComponent: Groups,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/admins/roles',
        pageComponent: Admins,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/admins',
        pageComponent: AppAdmins,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/admins/invite',
        pageComponent: InviteAppAdmin,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/groups/new',
        pageComponent: GroupNew,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/admins/new',
        pageComponent: AdminNew,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/groups/:groupId',
        pageComponent: GroupDetails,
    },
    {
        path: '/organizations/:organizationId/apps/:appId/groups/:groupId/user/create',
        pageComponent: CreateAdminRole,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/admins/:groupId',
        pageComponent: AppAdminDetails,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/groups/:groupId/permissions',
        pageRenderer: function (props) { return (_jsx(Permissions, __assign({}, props, { type: "group", baseUrl: "/groups", crumbIter: 2 }))); },
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/groups/:groupId/addmember',
        pageComponent: UserGroups,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/admins/:groupId/addmember',
        pageComponent: UserGroups,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/push',
        pageComponent: OldPushNotifications,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/push/new',
        pageComponent: OldPushNotifications,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/push/notifications',
        pageComponent: PushNotifications,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/push/notifications/:pushId([0-9]+)',
        pageComponent: PushNotificationDetailsPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/push/notifications/new',
        pageComponent: PushNotificationDetailsPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/push/notifications/new/:groupId',
        pageComponent: PushNotificationDetailsPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/push/notifications/:pushId([0-9]+)/permissions',
        pageRenderer: function (props) { return (_jsx(Permissions, __assign({}, props, { type: "push", baseUrl: "/push/notifications", crumbIter: 2 }))); },
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/push/templates',
        pageComponent: PushNotificationTemplates,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/push/templates/:templateId',
        pageComponent: PushNotificationTemplatesEdit,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)/push/senderapps',
        pageComponent: PushNotificationsSenderApps,
    },
    {
        path: '/organizations/:organizationId/apps/:appId/overview',
        pageComponent: AppOverview,
    },
    {
        path: '/organizations/:organizationId/apps/:appId/settings/:open?',
        pageComponent: AppSettings,
    },
    {
        path: '/organizations/:organizationId/apps/:appId/settings/:open?',
        pageComponent: AppSettings,
    },
    {
        path: '/organizations/:organizationId/apps/:appId/template',
        pageComponent: MakeTemplateBasicPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId/template/selectPreview',
        pageComponent: SelectPreview,
    },
    {
        path: '/organizations/:organizationId/apps/:appId/template/personalization',
        pageComponent: personalizationPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId/template/publish',
        pageComponent: TemplatePublishPage,
    },
    {
        path: '/organizations/:organizationId/apps/:appId([0-9]+)',
        pageComponent: PatchSelectRedirectPage,
    },
];
